import { useEffect, useMemo, useState } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import MessageModal from '../../components/atoms/Modal/MessageModal/MessageModal'
import { fetchAuthSession } from 'aws-amplify/auth'
import { useUserContext } from '../../context/UserContext'

function ShopifyCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams()
  const [loading, setLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const { refetchUser } = useUserContext()

  const params = useMemo(() => {
    const code = searchParams.get('code');
    const hmac = searchParams.get('hmac');
    const host = searchParams.get('host');
    const shop = searchParams.get('shop');
    const state = searchParams.get('state');
    const timestamp = searchParams.get('timestamp');
    return { code, hmac, host, shop, state, timestamp };
  }, [searchParams]);

  const clearShopifyTemp = () => {
    sessionStorage.removeItem('shopify_oauth_state')
    sessionStorage.removeItem('shopify_oauth_shop')
  }

  useEffect(() => {
    const run = async () => {
      try {
        if (!params?.code || !params?.shop) {
          navigate('/shopify-connect', { replace: true });
          return
        }

        const expectedState = sessionStorage.getItem('shopify_oauth_state')
        const expectedShop = sessionStorage.getItem('shopify_oauth_shop')

        if (!params?.state || !expectedState || params.state !== expectedState) {
          navigate('/shopify-connect', { replace: true })
          return
        }

        if (expectedShop && params.shop && params.shop.toLowerCase() !== expectedShop.toLowerCase()) {
          navigate('/shopify-connect', { replace: true })
          return
        }

        setLoading(true);
        const endpoint = 'https://jupexvi9zd.execute-api.us-east-1.amazonaws.com/staging/shopify/oauth'
        const brand = localStorage.getItem('brand') || ''
        const query = new URLSearchParams({
          code: params.code || '',
          hmac: params.hmac || '',
          host: params.host || '',
          shop: params.shop || '',
          state: params.state || '',
          timestamp: params.timestamp || '',
          brand,
        });

        const { tokens } = await fetchAuthSession()
        const idToken = tokens?.idToken?.toString?.()

        const resp = await fetch(`${endpoint}?${query.toString()}`, {
          method: 'GET',
          headers: {
            ...(idToken ? { Authorization: `Bearer ${idToken}` } : {}),
          },
        })
        let json
        try {
          json = await resp.json()
        } catch (e) {
          json = null
        }
        console.log('json', json)
        const isConnected = Boolean(json?.isShopifyConnected) || resp.ok
        if (isConnected) {
          try { await refetchUser?.() } catch (e) { }
          clearShopifyTemp()
          setShowSuccess(true)
        } else {
          clearShopifyTemp()
          navigate('/shopify-connect', { replace: true })
        }
      } catch (e) {
        navigate('/shopify-connect', { replace: true })
      } finally {
        setLoading(false)
      }
    }
    run()
  }, [params, navigate])

  return (
    <>
      <div className="min-h-[200px] flex flex-col items-center justify-center gap-2">
        <div className="text-lg font-medium font-montserrat">Finalizing connection…</div>
        <div className="text-sm text-gray-600 font-montserrat">Processing Shopify response{loading ? '…' : '.'}</div>
      </div>
      <MessageModal
        title={'Shopify connection successful'}
        description={'Your Shopify store has been connected. You can now manage your products and orders from the dashboard.'}
        showModal={showSuccess}
        onClose={() => {
          setShowSuccess(false)
          navigate('/stripe-connect', { replace: true })
        }}
      />
    </>
  )
}

export default ShopifyCallback;